export const isotonicasProducts = [
  {
    id: 1,
    name: 'Gatorade Cold Blue 1 L',
    image: 'https://public.readdy.ai/ai/img_res/0f6d9197-2e75-445d-afda-59e3edc63c0f.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1290,
    packPrice: 7740,
  },
  {
    id: 2,
    name: 'Gatorade Frutas Tropicales 1 L',
    image: 'https://public.readdy.ai/ai/img_res/3c71a682-2223-4416-980e-914237024580.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1290,
    packPrice: 7740,
  },
  {
    id: 3,
    name: 'Gatorade Cold Blue 750 ml',
    image: 'https://public.readdy.ai/ai/img_res/c5f80a3f-ba92-48f0-88d3-474829bef653.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 995,
    packPrice: 5970,
  },
  {
    id: 4,
    name: 'Gatorade Frutas Tropicales 750 ml',
    image: 'https://public.readdy.ai/ai/img_res/1b7f2140-88ae-4bea-ad81-0eea66996dfb.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 995,
    packPrice: 5970,
  },
  {
    id: 5,
    name: 'Powerade Frozen Blast 1.1 L',
    image: 'https://public.readdy.ai/ai/img_res/81abb738-ab60-4673-90ab-8c8abeb26cc8.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1290,
    packPrice: 7740,
  },
  {
    id: 6,
    name: 'Powerade Rojo 1.1 L',
    image: 'https://public.readdy.ai/ai/img_res/01b0e734-857f-4536-9a18-39edd9b30383.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1290,
    packPrice: 7740,
  },
  {
    id: 7,
    name: 'Powerade Naranja 1.1 L',
    image: 'https://public.readdy.ai/ai/img_res/6c869b8d-043d-4556-b507-fb03a57e9e7a.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 1290,
    packPrice: 7740,
  },
  {
    id: 8,
    name: 'Powerade Frozen Blast 850 ml',
    image: 'https://public.readdy.ai/ai/img_res/6c8ba00d-0fef-4f0a-ad17-e4233bb56dbb.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 930,
    packPrice: 5580,
  },
  {
    id: 9,
    name: 'Powerade Rojo 850 ml',
    image: 'https://public.readdy.ai/ai/img_res/a78826d5-32b0-4062-b1af-0d685b1e0ad0.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 930,
    packPrice: 5580,
  },
  {
    id: 10,
    name: 'Powerade Naranja 850 ml',
    image: 'https://public.readdy.ai/ai/img_res/7481665f-174d-4006-9199-4e162a4f0e77.png',
    unitsPerPack: 6,
    packagingType: 'Display',
    unitPrice: 930,
    packPrice: 5580,
  },
];
